import { Box, Typography } from "@mui/material";

import { CardCore } from "src/Pages/components/CardCore/CardCore";

import moment from "moment";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { toAbsoluteUrl } from "src/shared/setup/toAbsoluteUrl";

moment.locale("pt-br");

export const CardCredit = () => {
  const { userPerfil } = useAuthContext();

  const objCreditCard = {
    VISA: toAbsoluteUrl("/media/Cards/visa.svg"),
    MASTERCARD: toAbsoluteUrl("/media/Cards/master.svg"),
    ELO: toAbsoluteUrl("/media/Cards/cartaoElo.svg"),
    AMERICAN_EXPRESS: toAbsoluteUrl("/media/Cards/americanExpressIcon.svg"),
  };

  return (
    <CardCore
      sxStyle={{
        maxWidth: "100%",
        m: 0,
        "& > *": { fontWeight: 500 },
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "14px", sm: "20px" },
          fontWeight: "500",
          mb: "18px",
        }}
      >
        Forma de pagamento 💳
      </Typography>

      <Box display="flex" mb="14px" alignItems="center">
        <Box
          sx={{
            border: "1px solid rgba(151, 153, 241, 0.322)",
            borderRadius: "8px",
            p: 1,
            mr: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "30px", height: "30px" }}
            src={
              objCreditCard[
                userPerfil?.subscription?.creditCard?.creditCardBrand.toUpperCase() as keyof typeof objCreditCard
              ]
            }
            alt={userPerfil?.subscription?.creditCard?.creditCardBrand}
          />
        </Box>

        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
          •••• •••• ••••{" "}
          {userPerfil?.subscription?.creditCard?.creditCardNumber}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "8px",
          "& > *": {
            fontSize: "17px",
          },
        }}
      >
        <Typography sx={{ mr: 1 }}>
          Expira em ...
          {/* <strong>junho de 2027</strong> */}
        </Typography>
      </Box>
    </CardCore>
  );
};
